import module from "./dc-time-ago";
export default module;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-time-ago/index.js